import * as utils from '../shared/utils';
import picsioConfig from '../../../../config';

export default function () {
  const picsioSessionId = utils.getCookie(picsioConfig.events.sessionIDKey);
  if (!picsioSessionId) return null;

  return picsioSessionId;
}
